import React from 'react';
import { Avatar, Typography, Button } from 'antd';
import { MessageOutlined, CloseOutlined } from '@ant-design/icons';
import { formatChatDate } from '../../utils/chatUtils';

const { Text } = Typography;

const ChatNotification = ({ notification, onClose, onClick }) => {
  const { message, sender, createdAt, conversationId } = notification;
  
  const handleClick = () => {
    if (onClick) {
      onClick(conversationId);
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    if (onClose) {
      onClose(notification.id);
    }
  };

  return (
    <div className="chat-notification" onClick={handleClick}>
      <div className="chat-notification-header">
        <div className="chat-notification-sender">
          <Avatar 
            size="small" 
            src={sender?.avatar} 
            icon={<MessageOutlined />} 
            className="chat-notification-avatar"
          />
          <Text strong>{sender?.name || 'Nouveau message'}</Text>
        </div>
        <Button 
          type="text" 
          size="small" 
          icon={<CloseOutlined />} 
          onClick={handleClose}
          className="chat-notification-close"
        />
      </div>
      <div className="chat-notification-content">
        <Text ellipsis className="chat-notification-message">
          {message?.content || 'Nouveau message'}
        </Text>
        <div className="chat-notification-time">
          {formatChatDate(createdAt, { relative: true })}
        </div>
      </div>
    </div>
  );
};

export default ChatNotification;
